export const AUTH_REQUEST_TIMEOUT = 10000

const NETWORK_ERROR_CODES = ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT']

const isRetryableNetworkError = error => {
  if (!error || error.response) return false
  if (!error.isAxiosError && !error.config && !error.request) return false
  return NETWORK_ERROR_CODES.includes(error.code) ||
    error.message === 'Network Error' ||
    /timeout/i.test(error.message || '')
}

export const requestAuthInfoWithRetry = async (request, retries = 1) => {
  try {
    return await request()
  } catch (error) {
    if (retries <= 0 || !isRetryableNetworkError(error)) throw error
    return requestAuthInfoWithRetry(request, retries - 1)
  }
}

export const createSingleFlight = request => {
  let pending = null
  return (...args) => {
    if (!pending) {
      try {
        pending = Promise.resolve(request(...args))
      } catch (error) {
        pending = Promise.reject(error)
      }
      pending = pending.then(
          result => {
            pending = null
            return result
          },
          error => {
            pending = null
            throw error
          }
        )
    }
    return pending
  }
}
